// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js?minimize!../../../vue-loader/lib/style-rewriter.js?id=data-v-270681a8!../../../vue-loader/lib/selector.js?type=styles&index=0!./ColumnGroup.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("1d6ae45c", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-270681a8!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue2-datatable-component/src/HeaderSettings/ColumnGroup.vue
// module id = 1388
// module chunks = 2